/** Display name for client autocomplete (name + surname, no literal "null"). */
export function clientDisplayTitle(item) {
  const raw = item?.raw ?? item;
  if (!raw || typeof raw !== "object") return "";
  const name = raw.name != null ? String(raw.name).trim() : "";
  const surname = raw.surname != null ? String(raw.surname).trim() : "";
  return [name, surname].filter(Boolean).join(" ");
}

/** Vuetify v-autocomplete custom-filter for client lists. */
export function clientAutocompleteFilter(_item, queryText, itemText) {
  if (!queryText) return true;
  const searchText = String(queryText).toLowerCase();
  const label = clientDisplayTitle(itemText?.raw ?? itemText).toLowerCase();
  return label.includes(searchText);
}
